<template>
  <div class="header">
    <router-link to="/">
      <img class="logo" src="/static/image/logo.png">
    </router-link>
    <div class="right">
      <div class="search">
        <div class="searchRight">
          <input type="text"
                 class="historyTar"
                 v-model="keyword"
                 @keyup.enter="searchProduct"
                 @click="findSearchHistory"
                 placeholder="我要采购..."
          >
        </div>
        <span class="btn cur-poi" @click="searchProduct">
          <i class="icon el-icon-search"></i> 搜索
        </span>

        <!-- 历史搜索 -->
        <div v-show="showHistory" class="historyBox">
          <div class="deleteBtn">
            <label class="fs14 font-color-DDD" @click="historyDelAll">删除历史</label>
          </div>
          <ul>
            <li
              v-for="(item, index) in historyList"
              :key="item.searchId"
              @click="historyKeyword(item.search)"
            >
              <span class="boxContent historyText line1">{{item.search}}</span>
            </li>
          </ul>
        </div>
      </div>

      <div class="btn cur-poi shopbtn" @click="searchShop">
        搜索商家
      </div>
    </div>
  </div>
</template>

<script>
  import {
    deleteAllSearch, getHistory
  } from '@/api/nav.js'
  import {mapGetters, mapMutations} from 'vuex'
  import Cookie from 'js-cookie'

  export default {
    name: 'homHeader',
    data() {
      return {
        keyword: '',
        searchVal: '宝贝',
        historyList: [],
        isLogin: false,
        showHistory: false
      }
    },
    watch: {
      '$store.state.isLogin': {
        handler(nVal, oVal) {
          this.isLogin = nVal
        }
      }
    },
    created() {
      if (Cookie.get('token')) {
        this.isLogin = true

        let that = this;
        document.addEventListener('click', function (e) {
          if (e.target.className != 'historyTar') {
            that.showHistory = false
          }
        })
      }
    },
    methods: {
      ...mapMutations({
        setSearchObj: 'SET_SEARCHOBJ'
      }),
      // 查找
      searchPro() {
        if (!this.keyword) {
          return this.$message.error('请输入搜索内容')
        }

        let obj = {
          keyword: this.keyword,
          searchVal: this.searchVal
        }

        this.setSearchObj(obj)

        if (this.$route.name !== 'search') {
          this.$router.push({
            path: '/activity/search'
          })
        }
      },
      searchProduct() {
        this.searchVal = '宝贝'
        this.searchPro()
      },
      searchShop() {
        this.searchVal = '店铺'
        this.searchPro()
      },
      findSearchHistory() {
        if (this.isLogin) {
          getHistory().then(res => {
            this.historyList = res.data.data
            this.showHistory = this.historyList.length > 0
          }).catch(res => {

          })
        }
      },
      historyKeyword(search) {
        let obj = {
          keyword: search,
          searchVal: this.searchVal
        }

        this.setSearchObj(obj)
        this.$router.push({
          path: '/activity/search'
        })
      },
      historyDelAll() {
        this.$confirm('此操作将清空搜索记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.deleteAllSearch()
        }).catch(() => {
        })
      },
      deleteAllSearch() {
        deleteAllSearch().then((res) => {
          this.historyList = res.data.data
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  $lightBlack: #666666;
  .header {
    height: 120px;
    width: 1200px;
    margin: 0 auto;

    .logo {
      width: 320px;
      margin-top: 20px;
    }

    .right {
      float: right;
      margin-top: 41px;
      box-sizing: border-box;
      .search {
        width: 594px;
        height: 55px;
        line-height: 55px;
        border: 3px solid $mainColor;
        border-radius: 5px;
        float: left;
        display: flex;
        position: relative;

        .searchRight {
          flex: 1;

          input {
            padding-left: 15px;
            font-size: 18px;
            color: #333;
            line-height: 35px;
            width: 100%;
          }
        }

        .historyBox {
          width: 594px;
          position: absolute;
          height: 210px;
          border: 3px solid $mainColor;
          top: 57px;
          left: -3px;
          border-top: 0;
          overflow: hidden;
          background-color: #fff;
          z-index: 999;

          .deleteBtn {
            position: absolute;
            bottom: 0;
            right: 10px;
            line-height: 25px;

            label {
              line-height: 25px;
              cursor: pointer;
            }
          }

          ul {
            overflow: hidden;

            li {
              width: 90%;
              padding: 0 20px;
              color: #999;
              cursor: pointer;
              float: left;
              line-height: 35px;
              font-size: 18px;

              &:hover {
                color: $mainColor;
              }
            }
          }
        }
      }

      .btn {
        font-size: 20px;
        line-height: 54px;
        height: 56px;
        padding: 0 15px;
        background-color: $mainColor;
        color: #fff;
        margin-top: -1px;
        margin-right: -1px;
      }

      .shopbtn {
        float: right;
        margin-left: 15px;
        line-height: 60px;
        height: 60px;
        border-radius: 5px;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/base/homHeader.vue